module.exports = __webpack_public_path__ + "img/xinliuPic.b903aa6f.png";